import React from 'react';
import './index.scss';
import { getDate } from '../../../utils/dateUtils';

function PurchaseBillInvoice({ printPdfRef, purchaseBillDetails, handleProduct }) {
	const {
		vendor,
		bill_number,
		bill_date,
		due_date,
		due_amount,
		excess_amount,
		organisation,
		purchase_receive,
		purchase_order_number,
		purchase_bill_payment_made,
		purchase_bill_products,
	} = purchaseBillDetails || {};
	const { email, vendor_name, phone_mobile, vendor_address } = vendor || {};

	function calculateTotalTax(productTable) {
		const pbProducts = productTable.map((data) => ({
			amount: data.amount,
			tax1: data?.product?.tax1,
			tax2: data?.product?.tax2,
		}));
		let totalTax1 = pbProducts?.reduce(
			(sum, item) => Number(sum) + (Number(item.amount ?? 0) * Number(item.tax1 ?? 0)) / 100,
			0,
		);
		let totalTax2 = pbProducts?.reduce(
			(sum, item) => Number(sum) + (Number(item.amount ?? 0) * Number(item.tax2 ?? 0)) / 100,
			0,
		);
		return Number(totalTax1) + Number(totalTax2);
	}

	return (
		purchaseBillDetails && (
			<div
				ref={printPdfRef}
				className="invoice-container"
				style={{ marginTop: '25px', marginBottom: '25px' }}
			>
				{/* Header Section */}
				<p>
					Status:{' '}
					{purchaseBillDetails?.status === 0
						? 'Draft'
						: purchaseBillDetails?.status === 1
							? 'Open'
							: purchaseBillDetails?.status === 2
								? 'Partially Paid'
								: 'Paid'}
				</p>
				<div className="invoice-header">
					<div>
						<h2 style={{ fontSize: '22px', fontWeight: 'bold', color: '#0F1C35' }}>
							{vendor_name}
						</h2>
						<div style={{ marginTop: '15px', color: '#555B67' }}>
							<p>{`${vendor_address?.street_1 || 'N/A'}`}</p>
							<p>{`${vendor_address?.state?.name || 'N/A'}, ${vendor_address?.country?.name || 'N/A'}-${vendor?.vendor_address?.zip_code || 'N/A'}`}</p>
							<p>{`${phone_mobile || 'N/A'} | ${email || 'N/A'}`}</p>
						</div>
					</div>
					<div className="bill-status">
						<h2 style={{ fontSize: '30px', fontWeight: 'bold' }}>Purchase Bill</h2>
						<p style={{ marginTop: '10px', color: '#555B67' }}>Bill# {bill_number}</p>
						<p style={{ marginTop: '10px', color: '#555B67' }}>
							{purchase_receive?.purchase_receive_number}
						</p>
						<p style={{ marginTop: '10px', color: '#555B67' }}>{purchase_order_number}</p>
					</div>
				</div>

				{/* Invoice Details */}
				<div className="invoice-details">
					<div style={{ marginTop: '18px', color: '#555B67', fontSize: '14px' }}>
						<p>Bill Date: </p>
						<p>Due Date: </p>
						<p>Terms:</p>
					</div>
					<div
						style={{
							marginRight: '148px',
							marginTop: '19px',
							fontWeight: 'bold',
							fontSize: '14px',
							color: '#000000',
						}}
					>
						<p>{getDate(bill_date)}</p>
						<p>{due_date != null ? getDate(due_date) : 'N/A'}</p>
						<p>
							{purchaseBillDetails?.vendor?.vendor_other_details?.payment_terms !== undefined &&
							purchaseBillDetails?.vendor?.vendor_other_details?.payment_terms !== null
								? purchaseBillDetails?.vendor?.vendor_other_details?.payment_terms
								: 'N/A'}
						</p>
					</div>
					<div style={{ marginTop: '18px' }}>
						<p style={{ fontSize: '14px', color: '#555B67' }}>Balance Due:</p>
						<h2
							style={{ fontSize: '18px', fontWeight: 'bold', color: '#000000', textAlign: 'right' }}
						>
							Rs {Number(due_amount ?? 0).toFixed(2) || '0.00'}
						</h2>
					</div>
				</div>

				{/* Bill To Section */}
				<div
					className="bill-to"
					style={{ border: '1px solid #ddd', padding: '13px' }}
				>
					<p style={{ color: '#0F1C35', fontSize: '16px', fontWeight: '600' }}>Bill To:</p>
					<h3 style={{ fontWeight: 'bold', color: '#3B58FF', fontSize: '14px' }}>
						{organisation?.organisation_name}
					</h3>
				</div>

				{/* Items Table */}
				<table className="invoice-table">
					<thead>
						<tr>
							<th>#</th>
							<th>ITEM & DESCRIPTION</th>
							<th>QNTY</th>
							<th>RATE</th>
							<th>AMOUNT</th>
						</tr>
					</thead>
					<tbody>
						{purchase_bill_products?.map((item, index) => (
							<tr key={index}>
								<td>{index + 1}</td>
								<td style={{ color: 'blue', cursor: 'pointer' }}>
									<strong onClick={() => handleProduct(item)}>{item.product.product_name}</strong>
									<br />
									<strong
										style={{ color: 'grey' }}
										onClick={() => handleProduct(item)}
									>
										{item?.batch_no}
									</strong>
								</td>
								<td>{item.quantity}</td>
								<td>{item.purchase_rate}</td>
								<td>{Number(item.amount).toFixed(2)}</td>
							</tr>
						))}
					</tbody>
				</table>

				{/* Total Section */}
				<div className="total-section">
					<div></div>
					<div
						className="totals"
						style={{
							fontSize: '14px',
							fontWeight: 'bold',
							color: '#555B67',
							marginLeft: '380px',
							textAlign: 'right',
						}}
					>
						<p>Sub Total: </p>
						<p>Taxes:</p>
						<p>Total: </p>
						<p>Payment Made:</p>
						<p>Balance Due:</p>
						<p>Excess Amount:</p>
					</div>
					<div style={{ color: '#555B67', textAlign: 'right' }}>
						<p style={{ fontSize: '14px' }}>
							<b>Rs.</b>
							{purchase_bill_products
								?.reduce((total, bill) => Number(total) + Number(bill.amount), 0)
								.toFixed(2)}
						</p>
						<p style={{ fontSize: '14px' }}>
							<b>Rs.</b> {calculateTotalTax(purchase_bill_products).toFixed(2)}
						</p>
						<p style={{ fontSize: '14px' }}>
							<b>Rs.</b>{' '}
							{Number(
								purchase_bill_products?.reduce(
									(total, bill) => Number(total) + Number(bill.amount),
									0,
								) + calculateTotalTax(purchase_bill_products),
							).toFixed(2)}
						</p>

						<p style={{ fontSize: '14px' }}>
							<b>Rs.</b>{' '}
							<span className="negative">
								{purchase_bill_payment_made
									?.reduce((total, made) => Number(total) + Number(made.payment_amount), 0)
									.toFixed(2)}
							</span>
						</p>
						<p style={{ fontSize: '14px' }}>
							<b>Rs.</b> {Number(due_amount).toFixed(2) || '0.00'}
						</p>

						<p style={{ fontSize: '14px' }}>
							<b>Rs.</b> {Number(excess_amount).toFixed(2) || '0.00'}
						</p>
					</div>
				</div>

				{/* Footer */}
				<div className="footer">
					<p>Authorized Signature: __________________________</p>
				</div>
			</div>
		)
	);
}

export default PurchaseBillInvoice;
